import { getApiError, useRequestWithFeedback } from "../../../composites";
import { useLibrary } from "../../../providers";

import { API } from "./api";

import type { OverrideRunProps } from "../../../composites";
import type { ApiError } from "../../../../types/models/v1/Error.types";

type ZEscrowResponse = {
  zescrow_form: string;
};

export const useFetchZEscrowHTML = () => {
  const { send, loading } = useRequestWithFeedback<ZEscrowResponse, ApiError>();

  const { throwToast } = useLibrary("toasts");

  const fetchHTML = (overrideRunProps: OverrideRunProps<ZEscrowResponse>) => {
    send({
      action: API.fetchZEscrow(),
      onError: async (error) => {
        const e = await getApiError(error);

        let message;

        if (e.id === "zescrow_user_not_enrolled") {
          message =
            "It looks like zescrow is not enabled. Please contact support if you would like to turn this service on for yourself or your organization.";
        } else {
          message = e.message || "Unable to connect to zescrow.";
        }

        throwToast({ kind: "error", message });
      },
      ...overrideRunProps,
    });
  };

  return { fetchHTML, loading };
};
